import React, { useReducer } from 'react';
import orderProcessService from '../services/orderProcess';

interface Props {
  children: any
}

const FormDataContext = React.createContext(null);

const actionsConst = {
  SET_PERSONAL: 'SET_PERSONAL',
  SET_PRIMARY_ADDRESS_INFO: 'SET_PRIMARY_ADDRESS_INFO',
  SET_SECONDARY_ADDRESS_INFO: 'SET_SECONDARY_ADDRESS_INFO',
  SET_DELIVERY_INFO: 'SET_DELIVERY_INFO',
};

const initialValue = {
  personal: {
    fieldAnrede: 'Herr',
    fieldLastname: '',
    fieldFirstname: '',
    fieldAhvNumber: '',
    fieldBirthDate: null,
    fieldPhone: '',
    fieldEmail: '',
    fieldValidFrom: null,
    fieldEstimatedStay: '',
    fieldUnlimitedStay: false,
    fieldReasonForStay: '',
    fieldComments: '',
  },
  primaryAddressInfo: {
    fieldAddress: '',
    fieldAddressNotFound: false,
    fieldStrasse: '',
    fieldNr: '',
    fieldPlz: '',
    fieldOrt: '',
    fieldLand: 'Schweiz',
  },
  secondaryAddressInfo: {
    fieldAddress: '',
    fieldAddressNotFound: '',
    fieldStrasse: '',
    fieldNr: '',
    fieldPlz: '',
    fieldOrt: '',
    fieldLand: 'Schweiz',
  },
  deliveryInfo: {
    fieldDeliveryAddressDifferent: false,
    fieldDeliveryCompany: '',
    fieldDeliveryLastname: '',
    fieldDeliveryFirstname: '',
    fieldAddress: '',
    fieldAddressNotFound: '',
    fieldStrasse: '',
    fieldNr: '',
    fieldPlz: '',
    fieldOrt: '',
    fieldLand: 'Schweiz',
  },
};

const reducer = (state, action) => {
  const {
    type,
    payload,
  } = action;

  switch (type) {
    case actionsConst.SET_PERSONAL: {
      return {
        ...state,
        personal: payload,
      };
    }

    case actionsConst.SET_PRIMARY_ADDRESS_INFO: {
      const { primaryAddressInfo } = state;
      return {
        ...state,
        primaryAddressInfo: {
          ...primaryAddressInfo,
          ...payload,
        },
      };
    }

    case actionsConst.SET_SECONDARY_ADDRESS_INFO: {
      const { secondaryAddressInfo } = state;
      return {
        ...state,
        secondaryAddressInfo: {
          ...secondaryAddressInfo,
          ...payload,
        },
      };
    }

    case actionsConst.SET_DELIVERY_INFO: {
      const { deliveryInfo } = state;
      return {
        ...state,
        deliveryInfo: {
          ...deliveryInfo,
          ...payload,
        },
      };
    }

    default:
      return state;
  }
};

const FormDataContextProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(reducer, initialValue);

  function setPersonal(personal) {
    dispatch({
      type: actionsConst.SET_PERSONAL,
      payload: personal,
    });
  }

  function setPrimaryAddressInfo(primaryAddressInfo) {
    dispatch({
      type: actionsConst.SET_PRIMARY_ADDRESS_INFO,
      payload: primaryAddressInfo,
    });
  }

  function setSecondaryAddressInfo(secondaryAddressInfo) {
    dispatch({
      type: actionsConst.SET_SECONDARY_ADDRESS_INFO,
      payload: secondaryAddressInfo,
    });
  }

  function setDeliveryInfo(deliveryInfo) {
    dispatch({
      type: actionsConst.SET_DELIVERY_INFO,
      payload: deliveryInfo,
    });
  }

  function fetchFormData(documentId) {
    return orderProcessService.fetchOrderDetails(documentId)
      .then((res) => {
        if (res) {
          dispatch({
            type: actionsConst.SET_PERSONAL,
            payload: res?.formData?.personal,
          });
          dispatch({
            type: actionsConst.SET_DELIVERY_INFO,
            payload: res?.formData?.deliveryInfo,
          });
          dispatch({
            type: actionsConst.SET_PRIMARY_ADDRESS_INFO,
            payload: res?.formData?.primaryAddressInfo,
          });
          dispatch({
            type: actionsConst.SET_SECONDARY_ADDRESS_INFO,
            payload: res?.formData?.secondaryAddressInfo,
          });
        }
        return res;
      });
  }

  const contextValue = {
    state,
    setPersonal,
    setSecondaryAddressInfo,
    setPrimaryAddressInfo,
    setDeliveryInfo,
    fetchFormData,
    dispatch,
  };

  return (
    <FormDataContext.Provider
      value={contextValue}
    >
      { children }
    </FormDataContext.Provider>
  );
};

FormDataContextProvider.defaultProps = {
  children: '',
};

export default { FormDataContext, FormDataContextProvider, actionsConst };
